/* eslint-disable */
/* globals $ */
import _ from 'underscore'
import * as d3 from 'd3'
// import '../bower_components/tablesorter/jquery.tablesorter.min' // eslint-disable-line
// import './tablesorter-widget'

let column = 'xwoba'

if (query.type) {
    column = query.type
    loadOptionHTML(column)
}

$(document).ready(() => {
    $('#container').on('click', '.btn', function () {
        const id = this.id.split('-')[1]
        $(`.pen-hide-${id}`).toggle()
        $(`.pen-border-${id}`).toggle()

        if ($(`#${this.id}`).text() === 'Show All') {
            $(`#${this.id}`).text('Hide')
        } else {
            $(`#${this.id}`).text('Show All')
        }
    })

    $('.type-link').click(function () {
        $(this).children('.options').toggle()
        // $('.options').toggle()
    })

    $('.option').click(function () {
        const { type } = this.dataset
        loadOptionHTML(type)
        window.history.pushState('', '', `?type=${type}`)
        loadAllTables()
    })
})

function loadOptionHTML(columnName) {
    $('.catType').html($(`[data-type="${columnName}"]`).html())
    column = columnName
}

let catbinType = []
for (const type in rolling) {
    catbinType.push({
        type,
        sort:
            type.indexOf('Pitcher') > -1
                ? Number(rolling[type][0].cat_bin) * 100
                : Number(rolling[type][0].cat_bin),
    })
}

loadAllTables()

function loadAllTables() {
    catbinType = _.sortBy(catbinType, 'sort')

    // $('#container').html('')
    const $containers = $('.flex-column')

    for (let i = 0; i < catbinType.length; i++) {
        rolling[catbinType[i].type] = _.sortBy(
            rolling[catbinType[i].type],
            (d) => Number(d[`${column}_delta`])
        )
        if (catbinType[i].type.indexOf('Batter') > -1) {
            rolling[catbinType[i].type].reverse()
        }

        const $el = $($containers.get(i))
        $el.html('')
        createTable(
            $el,
            catbinType[i].type,
            rolling[catbinType[i].type],
            column
        )
    }
}

function createTable($el, type, data, column) {
    $el.html(`
            <div style="position: relative;">
                <div style="float: left; width: 75%;"><h6>${
                    data[0].type_cat_bin.indexOf('Pitcher') > -1
                        ? 'Pitching '
                        : ''
                } ${data[0].cat_bin} PA ${$('.catType').eq(0).text()}</h6>
                </div>
                <div style="float: left; width: 25%; text-align: right;">
                    <div id="show-${type}" class="btn btn-default" style="padding: .1rem .5rem .1rem .5rem;">Show All</div>
                </div>
            </div>
            <table>
                <thead>
                <tr>
                    <th></th>
                    <th style="text-align: center;">THEN</th>
                    <th style="text-align: center;">NOW</th>
                    <th style="text-align: center;">Δ</th>
                </tr>
                </thead>
                <tbody>
                ${data
                    .map((d, i) => {
                        let css = ` pen-show`
                        if (i > 4 && i < data.length - 5) {
                            css = ` pen-hide-${type}`
                        }
                        let hiddenBar = ``

                        if (i == 4) {
                            hiddenBar = `<tr class="pen-border pen-border-${d.type_cat_bin}"><td colspan="4">
                            <div style="margin-top: 1.5rem; border-top: dashed 1px #3a909d; width: 100%;">&nbsp;</div>
                        </td></tr>`
                        }

                        return `<tr class="${css} pen-${type}">
                                <td>
                                    <img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/${
                                        d.player_team_id
                                    }.svg">        
                                    <img class="player-mug" onerror="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';" src="https://content.mlb.com/images/headshots/current/60x60/${
                                        d.player_id
                                    }.png"> 
                                    <a href="/savant-player/${
                                        d.slug
                                    }?stats=statcast-r-histograms-mlb" target="_blank">${
                            d.player_name
                        }</a></td>
                                <td style="text-align: center;">${removeLeadingZero(
                                    d[`penultimate_x_${column}`]
                                )}</td>
                                <td style="text-align: center;">${removeLeadingZero(
                                    d[`last_x_${column}`]
                                )}</td>
                                <td style="text-align: center;"><span style="color: ${highlightDelta(
                                    d[`${column}_delta`]
                                )}">${removeLeadingZero(
                            d[`${column}_delta`]
                        )} ${addArrow(d[`${column}_delta`])}</span></td>
                            </tr>${hiddenBar}`
                    })
                    .join('')}
                </tbody>
            </table>                
        `)
}

function addArrow(i) {
    if (Number(i) > 0) {
        return '↑'
    }
    if (Number(i) == 0) {
        return '–'
    }
    if (Number(i) < 0) {
        return '↓'
    }
}
function removeLeadingZero(value) {
    try {
        value = Number(value).toFixed(3)
        if (value && value.length) {
            if (value.length > 1 && value.substring(0, 1) === '0') {
                value = value.substring(1, value.length)
            } else if (value.length > 2 && value.substring(0, 2) === '-0') {
                value = `-${value.substring(2, value.length)}`
            }
        }
    } catch (ex) {}
    return value
}

function highlightDelta(i) {
    const color = d3
        .scaleLinear()
        .range(['#3661AD', '#3661AD', '#c2c2c2', '#D82129', '#D82129'])
        .domain([-1, -0.25, 0, 0.25, 1])

    return color(i)
}
